import { iso31661, iso31662 } from 'iso-3166';

export const getCountriesList = () => iso31661.filter(c => c.alpha2 !== 'AS' // American Samoa
  && c.alpha2 !== 'GU' // Guam
  && c.alpha2 !== 'MP' // Northern Mariana Islands
  && c.alpha2 !== 'PR' // Puerto Rico
  && c.alpha2 !== 'VI') // US Virgin Islands
  .sort((a, b) => a.name.localeCompare(b.name));

export const getCountryAlpha2FromAlphaCode = alphaCode => getCountriesList().find(
  c => c.alpha2 === alphaCode || c.alpha3 === alphaCode,
).alpha2 || '';

export const getCountrySubdivisions = (countryCode) => {
  const country = getCountriesList().find(c => c.alpha2 === countryCode);
  if (!country) {
    return [];
  }

  const subdivisionsInCountry = iso31662.filter(
    s => s.parent === countryCode,
  );

  let result = [];
  subdivisionsInCountry.forEach((subdivision) => {
    const subdivisionWithChildren = { ...subdivision };
    const childSubdivisions = iso31662
      .filter(s => s.parent === subdivision.code)
      .sort((a, b) => a.name.localeCompare(b.name));
    if (childSubdivisions.length > 0) {
      subdivisionWithChildren.children = childSubdivisions;
    }
    result.push(subdivisionWithChildren);
  });

  if (country.name === 'United States of America') {
    const usTerritories = {
      name: 'US Territories',
      code: 'US-TERR',
      parent: 'US',
      children: [
        { code: 'US-AS', name: 'American Samoa', parent: 'US' },
        { name: 'Guam', code: 'US-GU', parent: 'US' },
        { name: 'Northern Mariana Islands', code: 'US-MP', parent: 'US' },
        { name: 'Puerto Rico', code: 'US-PR', parent: 'US' },
        { name: 'US Virgin Islands', code: 'US-VI', parent: 'US' },
      ],
    };

    const armedForces = {
      name: 'Armed Forces',
      code: 'US-ARMED',
      parent: 'US',
      children: [
        {
          name: 'Armed Forces Americas',
          code: 'US-AA',
          parent: 'US',
        },
        { name: 'Armed Forces Europe', code: 'US-AE', parent: 'US' },
        { name: 'Armed Forces Pacific', code: 'US-AP', parent: 'US' },
      ],
    };

    const stateList = result.filter((state) => {
      const { code, name } = state;
      return (
        !usTerritories.children.some(c => c.code === code)
        && !armedForces.children.some(c => c.code === code)
        && name !== 'United States Minor Outlying Islands'
      );
    });

    result = [
      usTerritories,
      {
        name: 'State List',
        code: 'US-STATE',
        parent: 'US',
        children: stateList,
      },
    ];

    result.sort((a, b) => a.name.localeCompare(b.name));
    result.push(armedForces);

    return result;
  }

  return result.sort((a, b) => a.name.localeCompare(b.name));
};

export const getChildSubdivisionMatchingCountryAndState = (
  country,
  codePrefix,
) => {
  const subdivisions = getCountrySubdivisions(country);

  // eslint-disable-next-line no-restricted-syntax
  for (const subdivision of subdivisions) {
    if (subdivision.children) {
      const matchingChildren = subdivision.children.filter(child => child.code.includes(`-${codePrefix}`));
      if (matchingChildren.length > 0) {
        return matchingChildren[0];
      }
    }
  }

  return subdivisions.filter(child => child.code.includes(`-${codePrefix}`))[0];
};
